module.exports = "<p>view-bill-modal works!</p>\r\n"